import { useEffect, useState } from 'react';
import { ProfileLogo, Text } from 'src/components';
import { Select, Skeleton, Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { getTemplatesExchangeByIdAction } from '../../store/actions';
import TemplatesExchangeModal from './TemplatesExchangeModal';
import { Bars } from 'react-loader-spinner';
import './TemplatesExchangeModal.scss';
import { BackIconMobile } from 'src/icons';
import TemplatesExchangeInsight from './TemplatesExchangeInsight';
import { useAuth } from '@frontegg/react';
import { NoteTemplateIcon } from 'src/icons';
import { analytics } from 'src/services';

const TemplatesExchange = ({
  setTemplatesComponent,
  templateOverridesList,
  insightHealthTemplatesList,
}) => {
  const dispatch = useDispatch();
  const [selectedName, setSelectedName] = useState('');
  const [selectedTemplates, setSelectedTemplates] = useState('All templates');
  const [templateOpen, setTemplateOpen] = useState(false);
  // const [auraComponent, setAuraComponent] = useState(false);

  const [loading, setLoading] = useState(true);

  const [templateOverrideId, setTemplateOverrideId] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    if (
      templateOverridesList &&
      insightHealthTemplatesList &&
      templateOverridesList?.length >= 0 &&
      insightHealthTemplatesList?.length >= 0
    ) {
      setLoading(false);
    }
  }, [templateOverridesList, insightHealthTemplatesList]);

  useEffect(() => {
    analytics.track('Viewed Note Templates Exchange', { email: user?.email });
  }, [user?.email]);

  const handleBackButton = () => {
    analytics.track('Clicked Back Button In Note Templates Exchange', {
      email: user?.email,
    });
    // setAuraComponent(true);
    setTemplatesComponent(false);
  };

  const handleTemplateOpen = (template_overrides_id) => {
    analytics.track('Clicked Note Template Tile', { email: user?.email });
    setTemplateOverrideId(template_overrides_id);
    dispatch(
      getTemplatesExchangeByIdAction(template_overrides_id, setTemplateOpen)
    );
  };

  const templateFields =
    templateOverridesList?.map((template) => ({
      id: template?.template?.template_overrides_id,
      name: template?.template?.name,
      detail: 'Section headers',
      sections: template?.template?.body?.sections.map(
        (section) => section?.name
      ),
      generate: template?.encounter_count,
      users: template?.user_count,
      sharedTemp: template?.practitioner_template_overrides_count,
      practitionerName: template?.practitioner_name,
    })) || [];

  const uniquePractitionerNames = [
    ...new Set(templateFields.map((template) => template.practitionerName)),
  ];

  // Filter function
  const filteredTemplateFields = templateFields.filter(
    (template) =>
      selectedName === 'All' ||
      selectedName === '' ||
      template.practitionerName === selectedName
  );

  if (loading) {
    return (
      <div className="page-wrapper flex justify-center items-center absolute inset-0">
        <div>
          <Bars
            height="25"
            width="25"
            color="#00D090"
            ariaLabel="bars-loading"
            visible={true}
          />
        </div>
      </div>
    );
  }

  const handleTabClick = (tab) => {
    if (tab === 'All templates') {
      // eslint-disable-next-line no-undef
      analytics.track('Clicked All Templates Tile Filter In Note Templates', {
        email: user?.email,
      });
    } else {
      // eslint-disable-next-line no-undef
      analytics.track(
        'Clicked Insight Templates Tile Filter In Note Templates',
        {
          email: user?.email,
        }
      );
    }
    setSelectedTemplates(tab);
  };

  return (
    <div className="templatesexchange flex flex-col h-full">
      <div className="flex gap-4 px-10 relative z-20">
        <div className="text-4xl mt-2">
          <BackIconMobile onClick={handleBackButton} />
        </div>
        <div className="flex flex-col gap-1 justify-center w-full">
          <div className="text-4xl  text-left text-black font-bold ">
            Note templates{' '}
          </div>
          <div className="mt-5 flex items-center justify-center">
            <div className="tabs flex justify-center items-center gap-10">
              <div
                className={`border-0 text-xl cursor-pointer py-10 text-left px-9 ${
                  selectedTemplates === 'All templates'
                    ? 'bg-[#f0f0f0]'
                    : 'bg-[#f8f8f8]'
                } hover:bg-[#e5e5e5] rounded-xl shadow-xl w-[235px]`}
                onClick={() => handleTabClick('All templates')}
                id="all_templates"
              >
                <div className="text-2xl text-[#018749]">
                  <NoteTemplateIcon />
                </div>
                <p className="mt-5 text-black font-semibold">All templates</p>
                <p className="text-base font-medium">
                  {filteredTemplateFields.length} templates
                </p>
              </div>
              <div
                className={`border-0 text-xl cursor-pointer py-6 text-left px-9 ${
                  selectedTemplates === 'Insight health templates'
                    ? 'bg-[#f0f0f0]'
                    : 'bg-[#f8f8f8]'
                } hover:bg-[#e5e5e5] rounded-xl shadow-xl w-[235px]`}
                onClick={() => handleTabClick('Insight health templates')}
                id="insight_health_templates"
              >
                <div className="text-2xl text-[#ff6f00]">
                  <img
                    src="https://images.insighthealth.ai/favicon_logo%2B256x256.png"
                    width="40"
                    height="40"
                  />
                </div>
                <p className="mt-3 text-black font-semibold">
                  Insight Health templates
                </p>
                <p className="text-base font-medium">
                  {insightHealthTemplatesList?.length} templates
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedTemplates === 'All templates' &&
        (filteredTemplateFields.length === 0 ? (
          <div className="flex flex-grow justify-center items-center pt-20">
            <div className="bg-white p-10 rounded-lg shadow-lg text-base font-medium text-gray">
              Custom templates from all users will appear on this page
            </div>
          </div>
        ) : (
          <>
            <div className="mt-5 px-10">
              <Select
                placeholder="Filter by practitioner"
                onChange={(value) => setSelectedName(value)}
                options={[
                  { value: 'All', label: 'All' }, // Add "All" option
                  ...uniquePractitionerNames.map((name) => ({
                    value: name,
                    label: name,
                  })),
                ]}
                style={{
                  width: 200,
                  marginTop: '0.5rem',
                }}
                dropdownStyle={{
                  zIndex: 999999999,
                }}
              />
            </div>
            <div className="grid grid-rows-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-x-24 gap-y-5 px-10 mt-5">
              {filteredTemplateFields.map((item, i) => {
                const id = item.id;
                const heading = item.name;
                const desc = item.detail;
                const sect = item.sections;
                const gene = item.generate;
                const user = item.users;
                const share = item.sharedTemp;
                const name = item.practitionerName;
                const nameWithoutTitle = item.practitionerName?.replace(
                  'Dr. ',
                  ''
                );
                return (
                  <div key={i} className="pb-2">
                    <div
                      className="ant-dropdown-link"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                      <div className="profile-wrapper flex items-center pt-3 gap-1">
                        <ProfileLogo
                          getAllTemplatesExchangeList={templateOverridesList}
                          name={nameWithoutTitle}
                          className="profile-popover-logo mr-1 sm:mr-2 lg:mr-3"
                          practitioner_name={name}
                        />
                        <Text
                          type={'span'}
                          className="user-name mr-1 sm:mr-2 lg:mr-3 text-black font-medium"
                        >
                          <div id="template_owner">{name}</div>
                          <div className="text-xs text-gray-500">
                            {share} {share === 1 ? 'template' : 'templates'}{' '}
                            shared
                          </div>
                        </Text>
                      </div>
                    </div>
                    <div
                      className={`card h-72  bg-white border-2 shadow-xl border-transparent rounded-xl mt-4`}
                    >
                      <div
                        className="card-title relative text-base text-black font-medium text-center border-transparent shadow-md rounded-xl p-4 m-3 border-2"
                        style={{
                          backgroundImage:
                            'linear-gradient(to right, #ecf9ff, #ebf8fe, #e9f7fe, #e8f6fd, #e7f5fd, #e7f5fd, #e7f5fd, #e7f5fd, #e8f6fd, #e9f7fe, #ebf8fe, #ecf9ffc2)',
                        }}
                      >
                        <div className="flex items-center text-wrap w-1/2 2xl:w-full text-sm">
                          {heading}
                        </div>
                        <span
                          className="lg:text-sm text-[#018749] bg-[#caffca] text-xs absolute top-2 right-2 flex items-center justify-center rounded-full h-8 px-3 cursor-pointer"
                          onClick={() => {
                            handleTemplateOpen(id);
                          }}
                        >
                          Get note template
                        </span>
                      </div>
                      <div className="pl-3 cursor-pointer relative ">
                        {sect && sect.length > 0 ? (
                          <div
                            className="card-text lg:h-full h-[11rem] overflow-y-auto cursor-pointer flex  flex-wrap justify-between px-4 pt-2 pb-3 "
                            onClick={() => {
                              handleTemplateOpen(id);
                            }}
                          >
                            <div>
                              <div className="header&section ">
                                <div className="text-black text-lg py-1 font-medium">
                                  {desc}
                                </div>
                                <Tooltip
                                  title={
                                    <div
                                      className={`pt-1 overflow-y-auto ${sect && sect.length > 12 ? 'h-[35rem]' : 'h-fit '} w-[15rem]`}
                                    >
                                      {sect &&
                                        sect.length > 0 &&
                                        sect.map((sec, j) => (
                                          <div key={j}>
                                            <div className="text-black pb-1">
                                              <div>{sec}</div>
                                              <div>
                                                <Skeleton.Input
                                                  style={{
                                                    width: 200,
                                                    height: 10,
                                                  }}
                                                  active
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                    </div>
                                  }
                                  placement="right"
                                  arrow={false}
                                >
                                  <div className="pt-3 h-36 overflow-hidden cursor-pointer">
                                    {sect.map((sec, j) => (
                                      <div key={j} className="text-black pb-1">
                                        <div>{sec}</div>
                                        <div>
                                          <Skeleton.Input
                                            style={{ width: 200, height: 10 }}
                                            active
                                          />
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </Tooltip>
                              </div>
                            </div>
                            <div>
                              <p>
                                {gene} {gene === 1 ? 'note' : 'notes'} generated
                              </p>
                              <p>
                                {user} {user === 1 ? 'user' : 'users'}
                              </p>
                            </div>
                          </div>
                        ) : (
                          <div className="cursor-auto text-center text-base font-medium mt-[72px]">
                            There are no template sections
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        ))}
      {selectedTemplates === 'Insight health templates' && (
        <TemplatesExchangeInsight
          insightHealthTemplatesList={insightHealthTemplatesList}
        />
      )}

      <TemplatesExchangeModal
        isOpen={templateOpen}
        setIsOpen={setTemplateOpen}
        templateOverrideId={templateOverrideId}
      />
    </div>
  );
};

export default TemplatesExchange;
